module.exports = __webpack_public_path__ + "static/media/er.1ef7078c.svg";